import { IFilterElement } from "@dashboard/components/Filter";
import {
  ParentAttributeListUrlFilters,
  ParentAttributeListUrlFiltersEnum,
  ParentAttributeListUrlQueryParams,
} from "../../urls";
import {
  createFilterTabUtils,
  createFilterUtils,
  getMinMaxQueryParam,
} from "@dashboard/utils/filters";

export const PARENT_ATTRIBUTE_FILTERS_KEY = "parentAttributeFilters";

export function getFilterOpts(params: ParentAttributeListUrlFilters) {
  return {
    query: {
      active: params?.query !== undefined,
      value: params?.query || "",
    },
  };
}

export function getFilterVariables(params: ParentAttributeListUrlFilters) {
  return {
    search: params?.query,
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<ParentAttributeListUrlFiltersEnum>,
): ParentAttributeListUrlFilters {
  const { name } = filter;

  switch (name) {
    case ParentAttributeListUrlFiltersEnum.query:
      return { query: filter.value?.[0] || undefined };
  }
}

export const storageUtils = createFilterTabUtils<string>(PARENT_ATTRIBUTE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters, getFiltersCurrentTab } = createFilterUtils<
  ParentAttributeListUrlQueryParams,
  ParentAttributeListUrlFilters
>(ParentAttributeListUrlFiltersEnum);